import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { userHasPermission } from '@/utils/auth';
import { PagesPaths } from '@/enums';
import { Container } from '@/components';
import {
  faShip,
  faWarehouse,
  faSnowflake,
  faCar,
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { TabMenu } from './components/TabMenu/TabMenu';
import { ColdHubPage } from './pages/ColdHubPage/ColdHubPage';
import { RoRoPage } from './pages/RoRoPage/RoRoPage';
import { ShipPage } from './pages/ShipPage/ShipPage';
import { TerminalPage } from './pages/TerminalPage/TerminalPage';
import styles from './Dashboard.module.scss';

const dashboardSections = [
  {
    key: 'ship' as const,
    icon: faShip,
    content: <ShipPage />,
    role: 'Dashboard_buques',
  },
  {
    key: 'terminal' as const,
    icon: faWarehouse,
    content: <TerminalPage />,
    role: 'Dashboard_terminal',
  },
  {
    key: 'coldHub' as const,
    icon: faSnowflake,
    content: <ColdHubPage />,
    role: 'Dashboard_hub_de_frio',
  },
  {
    key: 'roro' as const,
    icon: faCar,
    content: <RoRoPage />,
    role: 'Dashboard_RORO',
  },
];

export const DashboardPage = () => {
  const { t } = useTranslation('dashboardPage');
  const navigate = useNavigate();

  const tabs = useMemo(() => {
    return dashboardSections
      .map((tab) => ({
        ...tab,
        label: t(`tabLabels.${tab.key}`),
      }))
      .filter((tab) => userHasPermission(tab.role));
  }, [t]);

  useEffect(() => {
    if (tabs.length) return;
    navigate(PagesPaths.Schedule);
  }, [tabs, navigate]);

  return (
    <Container className={styles.container}>
      <div className={styles.tabsContainer}>
        <TabMenu tabs={tabs} />
      </div>
    </Container>
  );
};
